import React, { Component } from "react";
import jwt_decode from "jwt-decode";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import history from "../history";
import { Modal, Button } from "react-bootstrap";
import "../../../node_modules/bootstrap/dist/css/bootstrap.min.css";

const openModalWithPopup = (pageRoute) => {
  history.push({
    pathname: "/admin/" + pageRoute,
    state: { showNewPopup: true },
  });
};
const openModal = (pageRoute) => {
  history.push({ pathname: "/admin/" + pageRoute });
};

export default class AdminHome extends Component {
  state = {
    showSignInDetails: "none",
    btnexternaluserclicked: false,
    showModal: false,
    sections: [
      {
        name: "Users Management",
        description:
          "Users are assigned to at least one profile and one role within this profile.\u000A" +
          "A user can have several profiles if need be.\u000A" +
          'Click "New User" to create a user or click "Manage Users" to view the users list and make updates on existing users.',
        newbutton: "New User",
        managebutton: "Manage Users",
        imgUrl: require("../../images/admin/usermanagement.png")
          .default,
        routeName: "useradministration",
        isVisible:
          jwt_decode(localStorage.getItem("token")).can_manage_users === "true",
      },
      {
        name: "Profiles Management",
        description:
          "A profile determines the scope of data a user has access to (country, division, agency, etc.).\u000A" +
          "It is the combination of a profile and a role that creates the users rights.\u000A" +
          'Click "New Profile" to create a profile or click "Manage Profiles" to view the profiles list and make updates on existing profiles.',
        newbutton: "New Profile",
        managebutton: "Manage Profiles",
        imgUrl: require("../../images/admin/userprofile.png").default,
        routeName: "profiles",
        isVisible:
          jwt_decode(localStorage.getItem("token")).can_manage_profiles === "true",
      },
      {
        name: "Roles Management",
        description:
          "A role defines the reading/writing rights of a user within the profile he/she has been assigned to.\u000A" +
          "It is the combination of a profile and a role that creates the users rights.\u000A" +
          'Click "New Role" to create a role or click "Manage Roles" to view the roles list and make updates on existing roles.',
        newbutton: "New Role",
        managebutton: "Manage Roles",
        imgUrl: require("../../images/admin/userrole.png").default,
        routeName: "roles",
        isVisible:
          jwt_decode(localStorage.getItem("token")).can_manage_roles === "true",
      },
      {
        name: "Agency Fees Management",
        description:
          "Agency fees are defined per year, country, agency, media and submedia.\u000A" +
          "Agency fees are for information only and will be displayed in the budget forms managed by the agencies.\u000A" +
          'Click "New Agency Fee" to create an agency fee or click "Manage Agency Fees" to view the agency fees list and make updates on existing fees.',
        newbutton: "New Agency Fee",
        managebutton: "Manage Agency Fees",
        imgUrl: require("../../images/admin/agencyfees2.png").default,
        routeName: "agencyfees",
        isVisible:
          jwt_decode(localStorage.getItem("token")).can_manage_agency_fees === "true",
      },
      {
        name: "Exchange Rates Management",
        description:
          "Exchange rates can be defined according to four consolidation currencies (EUR, USD, CNY and HKD) and three types of rates: Budget, R1 and R2.\u000A" +
          "Exchange rates are mandatory to run consolidated reports.\u000A" +
          'Click "New Exchange Rate" to create an exchange rate or click "Manage Exchange Rates" to view the exchange rates list and make updates on existing rates.',
        newbutton: "New Exchange Rate",
        managebutton: "Manage Exchange Rates",
        imgUrl: require("../../images/admin/exchangerates2.png")
          .default,
        routeName: "exchangerates",
        isVisible:
          jwt_decode(localStorage.getItem("token")).can_manage_exchange_rate === "true",
      },
      {
        name: "Vehicles Management",
        description:
          "Vehicles are defined per country, media and submedia.\u000A" +
          "Vehicles are then selected by the agencies when creating or updating the budget forms.\u000A" +
          'Click "New Vehicle" to create a vehicle or click "Manage Vehicles" to view the vehicles list and make updates on existing vehicles.',
        newbutton: "New Vehicle",
        managebutton: "Manage Vehicles",
        imgUrl: require("../../images/admin/vehiclemanagment.png")
          .default,
        routeName: "vehicles",
        isVisible:
          jwt_decode(localStorage.getItem("token")).can_manage_vehicles === "true",
      },
    ],
  };
  SignInClick = () => {
    toast.success("Hey, this is a Success Message");
    history.push("/admin");
  };
  handleClose = () => {
    this.setState({ showModal: false });
  };

  render() {
    return (
      <div className="div-padding-20-quick">
        <div className="div-adminhome-welcome">
          <label className="lbl-adminhome-welcome">Welcome</label>
        </div>
        <div className="div-adminhome-details row">
          {this.state.sections.map(
            (section) =>
              section.isVisible && (
                <div className="col-md-6 mb-3">
                  <div className="div-section-details">
                    <div className="div-section-header">
                      {" "}
                      <img 
                        src={section.imgUrl} 
                        alt={section.name} 
                        height={34} />
                      <label>{section.name}</label>
                    </div>
                    <div className="div-section-paragraph">
                      <p style={{ whiteSpace: "pre-wrap" }}>
                        {section.description}
                      </p>
                    </div>
                    <div className="div-section-buttons">
                      <button
                        className="btn-section-details"
                        onClick={() => openModalWithPopup(section.routeName)}
                      >
                        <span>{section.newbutton}</span>
                      </button>
                      <button
                        className="btn-section-details"
                        onClick={() => openModal(section.routeName)}
                      >
                        <span>{section.managebutton}</span>
                      </button>
                    </div>
                  </div>
                </div>
              )
          )}
        </div>

        <Modal show={this.state.showModal} onHide={this.handleClose}>
          <Modal.Header closeButton>
            <Modal.Title>Modal heading</Modal.Title>
          </Modal.Header>
          <Modal.Body>Woohoo, you're reading this text in a modal!</Modal.Body>
          <Modal.Footer>
            <Button variant="secondary" onClick={this.handleClose}>
              Close
            </Button>
            <Button variant="primary" onClick={this.handleClose}>
              Save Changes
            </Button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
